import Navigation from './navbar';

const components = {
  Navigation,
};

export default components;
